import React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { __ } from '@wordpress/i18n';

// components
import ActivityFilters from '../ActivityFilters';
import ScopeBar from '../ScopeBar';
import ActivityList from '../ActivityList';
import SectionHeader from '../SectionHeader';

// store
import { useCommCenter } from '../../context';

/**
 * Activities tab of the project sidebar: what is waiting for the user's review,
 * followed by the filterable feed of recent activities.
 */
const ActivitiesPanel = () => {
    const {
        reviewActivities,
        visibleActivities,
        unreadActivityCount,
        showArchived,
        setShowArchived,
        activityScope,
        loading,
        error,
    } = useCommCenter();

    if (loading) {
        return (
            <div className="commPanel">
                <p className="commCenter__empty">{__('Carico le attività…', 'soundbetween')}</p>
            </div>
        )
    }

    if (error) {
        return (
            <div className="commPanel">
                <p className="commCenter__empty">
                    {__('Non è stato possibile caricare le attività.', 'soundbetween')}
                </p>
            </div>
        )
    }

    return (
        <OverlayScrollbarsComponent
            element="div"
            className="commPanel"
            options={{ scrollbars: { autoHide: 'never' } }}
            defer>
            <ScopeBar subject="activities"/>
            <section className="commSection commSection--review">
                <h3 className="commSection__title commSection__title--plain">
                    {__('Attività da verificare', 'soundbetween')}
                </h3>
                {reviewActivities.length
                    ? <ActivityList activities={reviewActivities} archivedView={false}/>
                    : (
                        <p className="commCenter__empty">
                            {__('Nessuna attività in attesa della tua verifica.', 'soundbetween')}
                        </p>
                    )}
            </section>

            <section className="commSection commSection--divided">
                <SectionHeader
                    title={showArchived
                        ? __('Attività archiviate', 'soundbetween')
                        : __('Ultime attività', 'soundbetween')}
                    count={showArchived ? 0 : unreadActivityCount}
                    archiveActive={showArchived}
                    onToggleArchive={() => setShowArchived(!showArchived)}>
                    <ActivityFilters/>
                </SectionHeader>
                <ActivityList
                    activities={visibleActivities}
                    emptyLabel={activityScope
                        ? __('Nessuna attività per la selezione.', 'soundbetween')
                        : showArchived
                            ? __('L’archivio è vuoto.', 'soundbetween')
                            : __('Nessuna attività per questo filtro.', 'soundbetween')}/>
            </section>
        </OverlayScrollbarsComponent>
    )
}

export default ActivitiesPanel;
